'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    tooltip: {
      background: theme.tooltip.background,
      display: 'inline-flex',
      alignItems: 'center',
      padding: 8,
      borderRadius: theme.tooltip.borderRadius,
      position: 'absolute',
      top: 0,
      left: -100000,
      opacity: 0,
      zIndex: 100,
      transition: theme.transitionArr([['opacity', 200, 0], ['transform', 400, 0]])
    },
    bottomSide: {
      transform: 'translate3d(0,-4px,0)'
    },
    topSide: {
      transform: 'translate3d(0,4px,0)'
    },
    rightSide: {
      transform: 'translate3d(4px,0,0)'
    },
    leftSide: {
      transform: 'translate3d(-4px,0,0)'
    },
    active: {
      opacity: 1,
      transform: 'translate3d(0,0,0)'
    },
    text: {
      color: theme.tooltip.textColor,
      fontSize: theme.tooltip.textSize
    },
    arrow: {
      background: theme.tooltip.background,
      transform: 'rotate(45deg)',
      height: 6,
      width: 6,
      position: 'absolute'
    },
    bottom: {
      top: -3,
      left: 'calc(50% - 3px)'
    },
    top: {
      bottom: -3,
      left: 'calc(50% - 3px)'
    },
    right: {
      left: -3
    },
    left: {
      right: -3
    }
  };
};